var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCallIconBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 42,
    viewBox: "0 0 43 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_193_10179)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 21.6611,
    cy: 17,
    r: 17,
    fill: "#7E90EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.3095 24.728C24.6474 24.728 21.5928 23.5807 18.3361 20.3188C16.5392 18.5193 15.1467 16.4948 14.4055 14.6275C13.7766 12.9178 13.7766 11.523 14.4055 10.8931C14.4729 10.8257 14.5178 10.7806 14.5852 10.7132C14.6975 10.5782 14.8323 10.4207 14.967 10.2857C15.4611 9.7908 16.0227 9.27344 16.7413 9.27344C17.3702 9.27344 17.9767 9.6334 18.6055 10.4207C20.3574 12.6027 19.5938 13.3676 18.6505 14.3124L18.4932 14.4699C18.3359 14.6275 18.089 15.3022 20.7168 17.9342C22.626 19.8464 23.5019 20.2062 23.9286 20.2062C24.0409 20.2062 24.1307 20.1611 24.198 20.0937L24.3553 19.9361C24.8719 19.4188 25.3436 18.9463 26.0623 18.9463C26.6238 18.9463 27.365 19.2612 28.2409 19.9812C28.9598 20.611 29.319 21.1734 29.3864 21.7358C29.4313 22.6131 28.7125 23.2881 28.0837 23.8504C27.9713 23.963 27.8816 24.0529 27.7692 24.1203C27.455 24.5705 26.9384 24.7279 26.3095 24.7279L26.3095 24.728Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_193_10179",
    x: 0.661133,
    y: 0,
    width: 42,
    height: 42,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_193_10179"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_193_10179",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallIconBlue);
export default __webpack_public_path__ + "static/media/callIconBlue.2300589d5a6be201ac999a0ccc599f2a.svg";
export { ForwardRef as ReactComponent };